interface SidebarLayoutProps {
    sidebarContent: React.ReactNode;
    mainContent: React.ReactNode;
}

const SidebarLayout: React.FC<SidebarLayoutProps> = ({
    sidebarContent,
    mainContent,
}) => {
    return (
        <div className="flex pt-16">
            {/* Sticky Sidebar */}
            <div className="fixed left-0 top-16 w-64 h-[calc(100vh-4rem)] overflow-y-auto border-2">
                <div className="p-4">
                    {sidebarContent}
                </div>
            </div>

            {/* Main Content */}
            <div className="ml-64 flex-1 min-h-[calc(100vh-4rem)]">
                <div className="p-8">
                    {mainContent}
                </div>
            </div>
        </div>
    );
};

export default SidebarLayout;